<template>
    <div>
        <eqt-table
           :icon="icon"
           :color="color"
           :header-color="headerColor"
           :hide-search="hideSearch"
           :hide-pagination="hidePagination"
           :hide-show-btn="hideShowBtn"
           :hide-edit-btn="hideEditBtn"
           @refresh="refresh"
           @delete="deleteItem"
           :total="total"
           :loading="loading"
           :title="computedTitle"
           :subtitle="computedSubtitle"
           :items="items"
           hide-actions
           :headers="computedHeaders">
                <template slot="filters">
                    <v-flex lg3>
                        <v-select
                                :items="types"
                                v-model="vacation.type"
                                :error-messages="errors.first('type')"
                                :label="$t('Pages.Vacations.model.type')"
                                required
                                name="type"
                                color="indigo"
                                clearable
                                multiple
                                item-text="name"
                                item-value="id"
                        ></v-select>
                    </v-flex>
                    <v-flex lg3>
                        <v-select
                                :items="VacationRequestStatuses"
                                v-model="vacation.status"
                                :error-messages="errors.first('status')"
                                :label="$t('Pages.Vacations.model.status')"
                                required
                                name="status"
                                color="indigo"
                                clearable
                                multiple
                                item-text="value"
                                item-value="key"
                        ></v-select>
                    </v-flex>
                </template>
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.id }}</td>
                    <td class="text-xs-center">
                        <v-avatar slot="activator" size="30px">
                            <img :src="item.user.profile.avatar" :alt="item.user.profile.name">
                        </v-avatar>
                    </td>
                    <td>{{ item.user.profile.name}}</td>
                    <td class="text-indigo text--darken-1 text-xs-center"><b>{{ getLocaleDateFormat(item.start)}}</b> -- <b>{{getLocaleDateFormat(item.end)}}</b></td>
                    <td class="text-xs-center">{{item.isVacationDays ? item.duration : -1*item.duration}}</td>
                    <td>{{ item.vacationType.name}}</td>
                    <td>
                        <v-tooltip top v-if="item.vacationResponses && item.vacationResponses.length > 0">
                            <v-badge slot="activator" :color="getLocaleVacationStatus(item.status) == $t('VacationRequestStatuses.declined') ? 'red' : 'blue'">
                                <template slot="badge">
                                    <span>{{item.vacationResponses.length}}</span>
                                </template>
                                <span>{{ getLocaleVacationStatus(item.status)}}</span>
                            </v-badge>
                            <p class="text-capitalize" v-for="response in item.vacationResponses">{{getLocaleVacationStatus(response.status) + ' ' + $t('Common.by') + ' ' + response.user.profile.name}}</p>
                        </v-tooltip>
                        <span v-else>{{ getLocaleVacationStatus(item.status)}}</span>
                    </td>
                    <td class="text-xs-center">{{ item.collectiveVacation ? $t('Common.yes') : $t('Common.no')}}</td>
                    <td class="text-xs-right">
                        <v-tooltip top>
                            <v-btn slot="activator" class="mx-0" small flat icon color="tertiary lighten-2" :to="'/vacation-requests/' + item.id + '/show'">
                                <v-icon  small>mdi-eye-settings</v-icon>
                            </v-btn>
                            <span>{{$t('Core.Fields.show')}}</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <v-btn :disabled="!item.canRespond" slot="activator" class="mx-0" small flat icon color="warning" @click="respond(item.id)">
                                <v-icon  small>chat</v-icon>
                            </v-btn>
                            <span>{{$t('Core.Fields.respond')}}</span>
                        </v-tooltip>

                        <v-tooltip top v-if="!item.isVacationDays">
                            <v-btn slot="activator" class="mx-0" small flat icon color="indigo"  @click="print(item)">
                                <v-icon  small>mdi-download</v-icon>
                            </v-btn>
                            <span>{{$t('Core.Fields.download')}}</span>
                        </v-tooltip>
                    </td>
                    <slot name="items" :item="item"></slot>
                </template>
        </eqt-table>

        <respond-dialog @close="onCloseDialog" :dialog="dialog" :id="selectedId"></respond-dialog>
    </div>
</template>

<script>
    import EqtTable from '../../components/core/Table'
    import RespondDialog from './RespondDialog'
    import i18n from '@/i18n'
    export default {
        name: "vacations-table",
        components: {EqtTable, RespondDialog},
        props: {
            items: {
              type: Array,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                default: false
            },
            hideActions: {
                type: Boolean,
                default: false
            },
            icon: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: 'tertiary'
            },
            headerColor: {
                type: String,
                default: 'text-primary text--darken-3'
            },
            title: {
                type: String,
                default: null,
            },
            subtitle: {
                type: String,
                default: null,
            },
            hideSubtitle: {
                type: Boolean,
                default: false
            },
            hidePagination: {
                type: Boolean,
                default: false
            },
            hideSearch: {
                type: Boolean,
                default: false
            },
            hideShowBtn: {
                type: Boolean,
                default: false
            },
            hideEditBtn: {
                type: Boolean,
                default: false
            },
            sortable: {
                type: Boolean,
                default: true
            },
            appendHeaders: {
                type: Array,
                default: () => []
            },
        },
        data() {
            let data = {
                headers: [
                    {
                        sortable: this.sortable && true,
                        text: '#',
                        value: 'id'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.Users.model.avatar'),
                        value: 'profile.avatar',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Users.title_singular'),
                        value: 'name'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Vacations.model.period'),
                        value: 'start',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Vacations.model.duration'),
                        value: 'duration',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Pages.Vacations.model.type'),
                        value: 'type'
                    },
                    {
                        sortable: this.sortable && true,
                        text: i18n.t('Pages.Vacations.model.status'),
                        value: 'status'
                    },
                    {
                        sortable: false,
                        text: i18n.t('Pages.CollectiveVacations.title_singular') + '?',
                        value: 'collectiveVacation',
                        align: 'center'
                    },
                    {
                        sortable: this.sortable && false,
                        text: i18n.t('Core.Fields.actions'),
                        value: 'actions',
                        align: 'right'
                    },

                ],
                data: {},
                vacation: {type: null, status: ['requested', 'pending']},
                types: [],
                dialog: false,
                selectedId: null,
            };

            return data;
        },
        computed:{
            computedHeaders(){
                return this.headers.concat(this.appendHeaders);
            },
            computedTitle(){
                return this.title ? this.title : this.$t('Pages.Vacations.title');
            },

            computedSubtitle(){
                if(this.hideSubtitle){
                    return null;
                }
                return this.subtitle ? this.subtitle : this.$t('Common.table_subtitle');
            }
        },
        created(){
            this.getTypes();
        },
        methods: {
            onCloseDialog(refresh){
                this.dialog = false;
                refresh && this.refresh();
            },
            refresh(data){

                if(data) {
                    this.data = data;
                }
                else{
                    data = this.data;
                }

                data.status = this.vacation.status;
                data.type = this.vacation.type;
                this.$emit('refresh', data);
            },
            deleteItem(item){
                this.$emit('delete', item);
            },
            getTypes(){
                this.repositories.vacationType.all().then((response) => {
                   this.types = response.data.data;
                });
            },
            show(id){
              this.$emit('show', id);
            },
            respond(id){
                this.selectedId = id;
                this.dialog = true;
            },
            print(item){
                this.repositories.vacationRequest.pdf(item.id, this.$t('Pages.Vacations.decision_for') + ' ' + item.user.profile.name);
                this.repositories.vacationRequest.requestPdf(item.id, this.$t('Pages.Vacations.request_for') + ' ' + item.user.profile.name);
            },
        },
        watch: {
            'vacation.type': function(){
                this.refresh();
            },
            'vacation.status': function(){
                this.refresh();
            },
        }
    }
</script>

<style scoped>

</style>
